import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = [
  "Farm-Fresh",
  "Hand-Sorted",
  "Small-Lot",
  "Export-Ready",
  "Ongole · AP",
  "Bold Green",
  "Aromatic",
  "Since the Coast",
];

export const EditorialMarquee = () => {
  return (
    <section
      aria-label="Brand marquee"
      data-testid="marquee-section"
      className="relative bg-cream border-y border-charcoal/10 overflow-hidden py-6 md:py-8"
    >
      <Marquee
        speed={28}
        gradient={false}
        pauseOnHover
        className="font-serif italic"
      >
        {WORDS.map((w, i) => (
          <span
            key={`${w}-${i}`}
            className="mx-14 md:mx-20 inline-flex items-center gap-14"
          >
            <span
              className={`text-[9vw] md:text-[6vw] lg:text-[5.5rem] leading-none ${
                i % 2 === 0 ? "text-forest" : "text-stroke-gold"
              }`}
            >
              {w}
            </span>
            <span className="text-gold text-3xl md:text-5xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
